/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateRunTransfer,
  CreateRunTransfer$inboundSchema,
  CreateRunTransfer$Outbound,
  CreateRunTransfer$outboundSchema,
} from "./createruntransfer.js";

/**
 * Defines configuration for recurring transfers.
 */
export type Recur = {
  /**
   *   RRule as defined by RFC 5545 (https://www.rfc-editor.org/rfc/rfc5545#section-3.3.10).
   *
   * @remarks
   *   Generators available online at the following sites - https://freetools.textmagic.com/rrule-generator, https://jkbrzt.github.io/rrule/
   */
  recurrenceRule: string;
  /**
   * Defines the attributes of a transfer.
   */
  runTransfer: CreateRunTransfer;
  /**
   * True if the RRule set runs indefinitely.
   */
  indefinite?: boolean | undefined;
  start?: Date | undefined;
};

/** @internal */
export const Recur$inboundSchema: z.ZodType<Recur, z.ZodTypeDef, unknown> = z
  .object({
    recurrenceRule: z.string(),
    runTransfer: CreateRunTransfer$inboundSchema,
    indefinite: z.boolean().optional(),
    start: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });
/** @internal */
export type Recur$Outbound = {
  recurrenceRule: string;
  runTransfer: CreateRunTransfer$Outbound;
  indefinite?: boolean | undefined;
  start?: string | undefined;
};

/** @internal */
export const Recur$outboundSchema: z.ZodType<
  Recur$Outbound,
  z.ZodTypeDef,
  Recur
> = z.object({
  recurrenceRule: z.string(),
  runTransfer: CreateRunTransfer$outboundSchema,
  indefinite: z.boolean().optional(),
  start: z.date().transform(v => v.toISOString()).optional(),
});

export function recurToJSON(recur: Recur): string {
  return JSON.stringify(Recur$outboundSchema.parse(recur));
}
export function recurFromJSON(
  jsonString: string,
): SafeParseResult<Recur, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Recur$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Recur' from JSON`,
  );
}
